/** The Microsoft four squares, in one colour (it inherits the text colour, like GitHubMark). */
export function MicrosoftMark({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 16 16" aria-hidden className={className} fill="currentColor">
      <path d="M1 1h6.6v6.6H1zM8.4 1H15v6.6H8.4zM1 8.4h6.6V15H1zM8.4 8.4H15V15H8.4z" />
    </svg>
  );
}
